var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSort = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.13 2.35 5.37 7.94A1.2 1.2 0 0 0 6.24 10h11.52a1.2 1.2 0 0 0 .87-2.06l-5.76-5.59a1.25 1.25 0 0 0-1.74 0Zm1.74 19.3 5.76-5.59a1.2 1.2 0 0 0-.87-2.06H6.24a1.2 1.2 0 0 0-.87 2.06l5.76 5.59a1.25 1.25 0 0 0 1.74 0Z"
})));
export default SvgSort;